import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ButtonConfig } from '../../models';

@Component({
  selector: 'footer-mobile',
  templateUrl: './footer-mobile.component.html',
  styleUrls: ['./footer-mobile.component.scss'],
  standalone: false,
  animations: [
    trigger('showHide', [
      state('shown', style({ transform: 'translateY(0rem)' })),
      state('hidden', style({ transform: 'translateY(13rem)' })),
      transition('shown => hidden', animate('0.16s ease-out')),
      transition('hidden => shown', animate('0.16s 240ms ease-out')),
      transition('void => shown', [
        style({ transform: 'translateY(13rem)' }),
        animate('0.16s 1s ease-out'),
      ]),
    ]),
  ],
})
export class FooterMobileComponent {
  @Input() primary: ButtonConfig = {};
  @Input() primLoading = false;
  @Input() primDisabled = false;
  @Input() secondary: ButtonConfig = {};
  @Input() secLoading = false;
  @Input() secDisabled = false;
  @Input() hidden = false;
  @Input() valid = false;
  @Input() primCenteredIfNoSecondary = false;
  @Input() hasPrimaryBackground = false;
  tucieloButtonShow = false;

  @Output() primaryClicked = new EventEmitter();
  @Output() secondaryClicked = new EventEmitter();

  @HostBinding('style.background-color')
  get color() {
    return this.primLoading || this.primDisabled ? 'white' : 'transparent';
  }

  ngOnChanges() {
    if (this.primary.hoaButton) this.tucieloButtonShow = true;
  }

  primaryAction() {
    this.primaryClicked.emit();
  }

  secondaryAction() {
    this.secondaryClicked.emit();
  }

  get isHidden() {
    return this.hidden ? 'hidden' : 'shown';
  }
}
